/**
 * To distinguish between date and datetime
 */
export const isDateTime = (date?: string | Date): boolean => {
  if (!date || !date.toString().includes('T')) {
    return false
  }
  return true
}
